import React from 'react';
import { Icon, Menu } from 'antd';
import { FormattedMessage } from 'react-intl';
import styles from '../NavMenu/styles.less';
import { MENU_LEAD_VISITS_LIST, MENU_TARGET_GROUPS_LIST, MENU_LEAD_COMPANIES_LIST } from '../NavMenu';

export default function () {
  return {
    DYNAMIC_CONTENT: {
      code: 'DYNAMIC_CONTENT',
      label: (<FormattedMessage id="Component.NavMenu.DynamicContent" />),
      get navItem() {
        return (
          <Menu.Item key={MENU_TARGET_GROUPS_LIST}>
            <Icon className={[styles.navMenuIcon, styles.itemDynamicContent].join(' ')} />
            <span>{this.label}</span>
          </Menu.Item>
        );
      },
    },
    LEAD_MANAGEMENT: {
      code: 'LEAD_MANAGEMENT',
      label: (<FormattedMessage id="Component.NavMenu.LeadManagement" />),
      get navItem() {
        return (
          <Menu.SubMenu
            key="LEAD_MANAGEMENT"
            title={<span><Icon className={[styles.navMenuIcon, styles.itemLeadManagement].join(' ')} />{this.label}</span>}
          >
            <Menu.Item key={MENU_LEAD_VISITS_LIST}><FormattedMessage id="Component.NavMenu.LeadManagement.Visits" /></Menu.Item>
            <Menu.Item key={MENU_LEAD_COMPANIES_LIST}><FormattedMessage id="Component.NavMenu.LeadManagement.Companies" /></Menu.Item>
          </Menu.SubMenu>
        );
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/components/NavModules/NavModules.js